// components/booking/BookingStepper.js
import React from 'react';

const BookingStepper = ({ currentStep, isMobile, serviceDetails }) => {
  const steps = [
    { step: 0, label: "Service" },
    { step: 1, label: "Schedule" },
    { step: 2, label: "Vehicle" },
    { step: 3, label: "Pay" }
  ];
  
  return (
    <>
      {/* Progress Steps - Desktop */}
      <div className="hidden md:block mb-10">
        <div className="flex items-center max-w-3xl mx-auto">
          {steps.map((item, index, arr) => (
            <React.Fragment key={item.step}>
              <div className={`flex items-center justify-center h-10 w-10 rounded-full ${
                currentStep >= item.step ? 'bg-gradient-to-r from-blue-500 to-cyan-400 text-white' : 'bg-gray-200 text-gray-500'
              }`}>
                <span className="text-sm">{item.step + 1}</span>
              </div>
              
              {index < arr.length - 1 && (
                <div className={`flex-1 h-1 ${
                  currentStep > item.step ? 'bg-gradient-to-r from-blue-500 to-cyan-400' : 'bg-gray-200'
                }`}></div>
              )}
            </React.Fragment>
          ))}
        </div>
        
        <div className="flex max-w-3xl mx-auto mt-2">
          {steps.map((item) => (
            <div key={item.step} className="flex-1 text-center text-xs text-gray-600">{item.label}</div>
          ))}
        </div>
      </div>
      
      {/* Progress Steps - Mobile */}
      <div className="md:hidden mb-6">
        <div className="flex items-center justify-between px-6">
          {steps.map((item) => (
            <div 
              key={item.step}
              className={`flex items-center justify-center h-8 w-8 rounded-full ${
                currentStep >= item.step 
                  ? 'bg-gradient-to-r from-blue-500 to-cyan-400 text-white'
                  : 'bg-gray-200 text-gray-500'
              }`}
            >
              <span className="text-xs">{item.step + 1}</span>
            </div>
          ))}
        </div>
        <div className="flex justify-between px-2 mt-1">
          {steps.map((item) => (
            <div key={item.step} className="w-8 text-center text-xs text-gray-600">{item.label}</div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BookingStepper;